import * as api from '../../shared/api.js'

export function extractIdentifiers(item) {
    const keys = item && item.inquiry ? Object.keys(item.inquiry.providedKeys) : []
    return keys.map(key => {
        const constraint = item.profile.constraints.find(c => c.key === key)
        return {
            key   : constraint && constraint.description || key,
            value : item.inquiry.providedKeys[key]
        }
    })
}

export function loadInquiry(id) {
    return api.get(`/inquiry/${id}`).then(api.toJsonIf200)
}
